import React from "react";
import Checkbox from "antd/lib/checkbox";
import getFieldLabel from "../getFieldLabel";
import { useTheme } from "@/components/ThemeProvider";

export default function CheckboxField({ form, field, ...otherProps }) {
  const fieldLabel = getFieldLabel(field);
  const { isDarkMode } = useTheme();
  return <Checkbox {...otherProps} className={isDarkMode ? "dark-mode" : ""}>{fieldLabel}</Checkbox>;
}
